import ImageDes from "../../../assets/images/home/ImageDesul.svg";
import ImageOfGas from "../../../assets/images/home/ImageOfGas.svg";
import ImageVOC from "../../../assets/images/home/ImageVOC.svg";
import ImageAcid from "../../../assets/images/solutions/ImageAcid.svg";
import ImageBitumen from "../../../assets/images/solutions/ImageBitumen.svg";
import ImageVapour from "../../../assets/images/solutions/ImageVapour.svg";

export const GalleryItems = {
  AcidMistAndAerosols: {src: ImageAcid, alt: "Acid Mist and Aerosols"},
  OrganicMistsEAerosols: {src: ImageBitumen, alt: "Organic Mists & Aerosols"},
  AcidFumes: {src: ImageVapour, alt: "Acid Fumes & Inorganics"},
  Desulphurisation: {src: ImageDes, alt: "Desulphurisation"},
  VOC: {src: ImageVOC, alt: "VOC, odor & H₂S Control"},
  OfGas: {src: ImageOfGas, alt: "Off-gas treatment"},
};
